import { useSelector } from 'store';
import { ThemeDirection, ThemeMode } from 'types/config';

const useEditorCss = (theme, fullHeight = true) => {
  const { showRichText } = useSelector((state) => state.ui);
  const css = {
    '& .quill': {
      bgcolor: theme.palette.background.paper,
      border: '1px solid',
      borderColor: theme.palette.text.secondary,
      borderRadius: '4px',
      overflow: 'visible',
      '& .ql-container': {
        px: 2,
        py: 0.5,
        border: 'none',
        height: fullHeight ? 'calc(100vh - 260px)' : 'auto',
        fontFamily: 'inherit',
        fontSize: 'inherit'
      },
      '& .ql-editor': {
        px: 1,
        backgroundColor: 'white',
        color: 'black',
        borderRadius: '4px',
        '& *': {
          marginBlockStart: 0,
          marginBlockEnd: 1
        }
      },
      '& .ql-toolbar': {
        display: showRichText ? 'block' : 'none',
        pt: 1.25,
        border: 'none',
        borderBottom: '1px solid',
        borderColor: theme.palette.divider,
        bgcolor: theme.palette.mode === ThemeMode.DARK ? theme.palette.grey[100] : 'grey.50',
        '& .ql-formats': {
          marginRight: '12px'
        },
        '& button': {
          height: '24px',
          width: '24px',
          padding: '2px',
          margin: '1px',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '2px',
          color: theme.palette.text.secondary,
          '&:hover': {
            backgroundColor:
              theme.palette.mode === ThemeMode.DARK
                ? theme.palette.grey[500]
                : theme.palette.grey[200]
          },
          '&.ql-active': {
            backgroundColor:
              theme.palette.mode === ThemeMode.DARK
                ? theme.palette.primary.dark
                : theme.palette.primary.lighter,
            color:
              theme.palette.mode === ThemeMode.DARK
                ? theme.palette.text.secondary
                : theme.palette.primary.main
          }
        },
        '& .ql-picker': {
          color:
            theme.palette.mode === ThemeMode.DARK
              ? theme.palette.grey[100]
              : theme.palette.grey[700],
          '&.ql-expanded': {
            '& .ql-picker-options': {
              border: '1px solid',
              borderColor: theme.palette.text.secondary,
              backgroundColor:
                theme.palette.mode === ThemeMode.DARK
                  ? theme.palette.grey[700]
                  : theme.palette.text.secondary,
              boxShadow: theme.shadows[2],
              borderRadius: '2px'
            }
          },
          '& .ql-picker-label': {
            border: '1px solid',
            borderColor: theme.palette.text.secondary,
            borderRadius: '2px'
          },
          '& .ql-picker-options': {
            padding: '4px 0',
            '& .ql-picker-item': {
              padding: '4px 8px',
              color:
                theme.palette.mode === ThemeMode.DARK
                  ? theme.palette.grey[100]
                  : theme.palette.grey[700],
              '&:hover': {
                backgroundColor:
                  theme.palette.mode === ThemeMode.DARK
                    ? theme.palette.grey[600]
                    : theme.palette.grey[100]
              }
            }
          }
        },
        '& .ql-picker-label::before': {
          color:
            theme.palette.mode === ThemeMode.DARK
              ? theme.palette.text.secondary
              : theme.palette.grey[700]
        }
      },
      ...(theme.direction === ThemeDirection.RTL && {
        '& .ql-toolbar': {
          '& .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) .ql-picker-label': {
            paddingRight: '8px',
            paddingLeft: '2px'
          }
        }
      })
    }
  };
  return css;
};

export default useEditorCss;
